import { jsx as i } from "react/jsx-runtime";
import { createContext as u, useMemo as l, useContext as v } from "react";
const e = u({
  colorMode: void 0,
  loader: void 0,
  wrapper: void 0
}), c = ({
  colorMode: t,
  loader: o,
  wrapper: r,
  children: n
}) => {
  const s = l(
    () => ({ colorMode: t, loader: o, wrapper: r }),
    [t, o, r]
  );
  return /* @__PURE__ */ i(e.Provider, { value: s, children: n });
}, d = () => v(e);
export {
  c as IllustrationProvider,
  d as useIllustrationCtx
};
